export interface CookieArticle {
  title: string;
  content: {
    mainText?: string;
    bulletPoints?: string[];
    additionalText?: string[];
    contactInfo?: string;
  }[];
}

export const cookiesData: CookieArticle[] = [
  {
    title: "Politique de Cookies",
    content: [
      {
        mainText:
          "Le site du Tennis Club de l’Agglomération du Beauvaisis (TCAB) utilise uniquement des cookies essentiels au bon fonctionnement du site. Aucune donnée n’est utilisée à des fins publicitaires ou de suivi commercial.",
      },
    ],
  },
  {
    title: "Cookies essentiels",
    content: [
      {
        mainText: "Ces cookies sont strictement nécessaires pour :",
      },
      {
        bulletPoints: [
          "Assurer le maintien d’une navigation sécurisée",
          "Mémoriser vos préférences d’affichage et de navigation",
          "Garantir le bon fonctionnement technique du site",
        ],
      },
    ],
  },
  {
    title: "Absence de suivi publicitaire",
    content: [
      {
        mainText: "Le TCAB s’engage à :",
      },
      {
        bulletPoints: [
          "Ne pas utiliser de cookies publicitaires",
          "Ne pas partager vos données avec des tiers à des fins commerciales",
          "Ne pas intégrer de services de traçage externe",
          "Ne jamais revendre vos informations personnelles",
        ],
      },
    ],
  },
  {
    title: "Vos choix et droits",
    content: [
      {
        mainText: "Vous pouvez à tout moment :",
      },
      {
        bulletPoints: [
          "Configurer votre navigateur pour refuser tout ou partie des cookies (cela peut limiter certaines fonctionnalités)",
          "Supprimer les cookies déjà enregistrés via les paramètres de votre navigateur",
          "Utiliser la navigation privée pour limiter le stockage de cookies",
        ],
      },
    ],
  },
  {
    title: "Contact",
    content: [
      {
        mainText:
          "Pour toute question concernant l’utilisation des cookies sur ce site, vous pouvez nous écrire à :",
      },
      {
        contactInfo: "contact@tennis-club-agglo-beauvais.com",
      },
    ],
  },
];
